import { PrimaryButton } from "components/button/Button";
import { Input } from "components/input/Input";
import InfoIconTooltip from "components/tooltip/InfoIconTooltip";

type Props = {
  setSearchTerm: (searchTerm: string) => void;
  searchTerm?: string;
  isAllCustomers?: boolean;
  handleKeyUp?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  handleSearch?: (searchTerm: string) => void;
};

export default function CustomersHeader({
  setSearchTerm,
  isAllCustomers = false,
  handleKeyUp,
  searchTerm,
  handleSearch
}: Props) {
  const title = isAllCustomers ? "Alla kunder" : "Mina kunder";

  const renderInfo = () => (
    <InfoIconTooltip className="ml-3">
      <h4 className="mt-0">Mina Kunder är din startsida i MittKontor.</h4>
      <p>
        Här listas alla kunder som du är kopplad till via ett kundteam. Saknar
        du en kund här så behöver du kontakta kund/uppdragsansvarig för att bli
        tillagt på kunden som delansvarig i Maconomy eller medlem i kundteamet.
      </p>
    </InfoIconTooltip>
  );

  const renderSearchButton = () => (
    <PrimaryButton
      className="ml-4"
      onClick={() => {
        if (handleSearch && searchTerm) {
          handleSearch(searchTerm);
        }
      }}
      disabled={!searchTerm || (searchTerm && searchTerm.length === 0)}
    >
      Sök
    </PrimaryButton>
  );

  return (
    <div className="d-flex justify-content-between flex-wrap mb-4">
      <div>
        <h1 className="m-0 d-flex align-items-center">
          {title}
          {!isAllCustomers && renderInfo()}
        </h1>
        <hr className="header-border" />
      </div>
      <div
        className="d-flex w-100"
        style={{ maxWidth: "500px", height: "3em" }}
      >
        <Input
          className="mb-0"
          type="text"
          variant="rounded"
          placeholder="Sök på företagsnamn, organisationsnummer eller kundnummer"
          onChange={(e) => {
            setSearchTerm(e.target.value);
          }}
          onKeyUp={(e) => {
            if (handleKeyUp) {
              handleKeyUp(e);
            }
          }}
        />
        {isAllCustomers && renderSearchButton()}
      </div>
    </div>
  );
}
